import { Component, input, OnInit, output } from '@angular/core';
import { Data } from '@angular/router';
import { Collection } from 'app/classes/collection';
import { DataTable, IDataClassConfig } from 'app/classes/data-table/data-table';
import { Report } from 'app/classes/reports/report';

@Component({
  selector: 'app-report-collection-list',
  standalone: false,
  templateUrl: './report-collection-list.component.html',
  styleUrl: './report-collection-list.component.css',
})
export class ReportCollectionListComponent implements OnInit {

  report = input.required<Report>();
  onSelectChange = output<boolean>();

  dataTable: DataTable;
  dataTableConfig: IDataClassConfig = {
    'title': { valueType: 'string', title: 'Collection', align: 'left' },
    'siteTitle': { valueType: 'string', title: 'Site', align: 'left' },
    'typeTitle': { valueType: 'string', title: 'Type', align: 'left' }
  };

  constructor() {
    console.log('ReportCollectionListComponent');
  }

  ngOnInit(): void {
    this.dataTable = new DataTable({ data: this.report().collections }, this.dataTableConfig);
  }

  toggle(collection: any) {
    collection.selected = !collection.selected;

  }

  postToggle() {
    this.onSelectChange.emit(true);
  }
}
